import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import PopTeacherAssignment from './_PopTeacherAssignment';
function PopReservationRoom(props) {
  const {open, close} = props;
  const [modalTeacherAssignment, setModalTeacherAssignment] = useState(false); //수시 교사 배정
  return (
    <>
      <Modal open={open} close={close} type="pop_schedule_management" popSize="xl">
        <h2 className="pop_tit line">강의실 예약 스케줄 관리</h2>
        <div className="content_container scroll">
          <div className="com_calendar_wrap">
            <div className="year">
              <button className="btn btn_first"></button>
              <button className="btn btn_prev"></button>
              <button className="btn_txt">2023</button>
              <button className="btn btn_next"></button>
              <button className="btn btn_last"></button>
              <button className="btn btn_first"></button>
              <button className="btn btn_prev"></button>
              <button className="btn_txt">07</button>
              <button className="btn btn_next"></button>
              <button className="btn btn_last"></button>
            </div>
          </div>
          <div className="com_schedule_table__scroll">
            <table className="com_schedule_table">
              <colgroup>
                <col width="45" />
                <col width="71" />
                <col width="140" span={6} />
              </colgroup>
              <thead>
                <tr className="sticky top">
                  <th colSpan={2}></th>
                  <th>
                    201호<p className="com_red_txt">(All)</p>
                  </th>
                  <th>
                    202호<p className="com_red_txt">(월,화,수,금)</p>
                  </th>
                  <th>
                    203호<p className="com_red_txt">(월,화,수,금)</p>
                  </th>
                  <th>
                    204호<p className="com_red_txt">(월,화,수,금)</p>
                  </th>
                  <th>
                    205호<p className="com_red_txt">(월,화,수,금)</p>
                  </th>
                  <th>
                    사장실<p className="com_red_txt">(All)</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th rowSpan={8}>
                    25
                    <br />
                    (일)
                  </th>
                  <td>
                    1<br />
                    10:00
                  </td>
                  <td
                    className="has_schedule bg_red"
                    onClick={() => {
                      setModalTeacherAssignment(true);
                    }}
                  >
                    김학생103 (1회ㅣ/5회)
                    <br />
                    생디 ㅣ 90분
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    2<br />
                    11:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    3<br />
                    13:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    4<br />
                    14:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    5<br />
                    16:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    6<br />
                    17:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    7<br />
                    19:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    8<br />
                    20:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr className="divider">
                  <th rowSpan={8}>
                    26
                    <br />
                    (일)
                  </th>
                  <td>
                    1<br />
                    10:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    2<br />
                    11:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    3<br />
                    13:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    4<br />
                    14:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    5<br />
                    16:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    6<br />
                    17:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    7<br />
                    19:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    8<br />
                    20:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr className="divider">
                  <th rowSpan={8}>
                    27
                    <br />
                    (월)
                  </th>
                  <td>
                    1<br />
                    10:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    2<br />
                    11:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    3<br />
                    13:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    4<br />
                    14:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    5<br />
                    16:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    6<br />
                    17:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    7<br />
                    19:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    8<br />
                    20:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
      <PopTeacherAssignment open={modalTeacherAssignment} close={() => setModalTeacherAssignment(false)} /> {/* 20250218 퍼블 추가&수정 */}
    </>
  );
}

export default PopReservationRoom;
